import { render } from "./TyreBanners.vue?vue&type=template&id=7a1cb94b&scoped=true"
import script from "./TyreBanners.vue?vue&type=script&lang=js"
export * from "./TyreBanners.vue?vue&type=script&lang=js"

import "./TyreBanners.vue?vue&type=style&index=0&id=7a1cb94b&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1cb94b"]])

export default __exports__